<script setup>
  const { red } = defineProps({ red: Boolean });
</script>

<!----------------------------------------------------------------------------->

<template>
  <div class="wrapper" :class="{ red }">
    <Ticker class="ticker" noSpacer>
      <span class="parts">
        <slot />
        <slot />
      </span>
    </Ticker>
  </div>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  .wrapper {
    background-color: $black;

    height: px(34);

    @include break-large {
      height: px(31);
    }
    @include break-small {
      height: px(22.5);
    }

    overflow: hidden;

    :deep(.container) {
      @include heroic-regular(px(36));

      @include break-large {
        font-size: px(32);
      }
      @include break-small {
        font-size: px(24);
      }

      .parts {
        b {
          @include heroic-bold(px(36));
          @include break-large {
            font-size: px(32);
          }
          @include break-small {
            font-size: px(24);
          }
        }

        > span {
          display: inline-flex;
          align-items: center;

          padding: 0.15em 0.25em 0;

          // vs
          > span {
            font-size: px(18);

            margin-top: -0.1em;
            padding: 0 0.25em;
          }
        }
      }
    }

    &.red {
      :deep(.container) {
        .parts {
          color: $red;

          > span {
            b {
              color: $white;
            }
          }
        }
      }
    }

    &:not(.red) {
      :deep(.container) {
        .parts {
          > span {
            &:nth-of-type(odd) {
              b {
                @include gold-text;
                margin-top: -0.1em;
              }
            }

            &:nth-of-type(even) {
              color: $black;
              @include gold-background;
            }
          }
        }
      }
    }
  }
</style>
